import { ConcreteEncodable } from "./ConcreteEncodable";

import { SSOTokenEncoder } from "../../encoder/SSOTokenEncoder";

import * as CubiqTS from "../../index";

export class SSOToken extends ConcreteEncodable {
  public static enType: string = "com.bcdfx.security.SSOToken";

  /*FID=1*/
  public token: string;
  /*FID=2*/
  public timeStamp: CubiqTS.Long | null = null;
  /*FID=100*/
  public messageId: string;

  constructor() {
    super();
    this.encoder = SSOTokenEncoder.Instance;
    this.setEncodableType(SSOToken.enType);
    //Model
  }

  public toString(): string {
    return (
      "SSOToken[" +
      "token=" +
      this.token +
      "timeStamp=" +
      this.timeStamp +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
